import { render } from "./OPINION_GENERATED_BY_VOTING_ORG.vue?vue&type=template&id=f37f0b5e"
import script from "./OPINION_GENERATED_BY_VOTING_ORG.vue?vue&type=script&lang=js"
export * from "./OPINION_GENERATED_BY_VOTING_ORG.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__